import { Link } from "gatsby";
import React from "react";

const AnchorLink = ({ subdir }) => {
  return ({ href, children }) => {
    if (href.startsWith("/") && !href.includes(".xml")) {
      return <Link to={href}>{children}</Link>;
    }
    return (
      <a
        href={
          href.includes(".xml") && href.startsWith("/") ? subdir + href : href
        }
        target={
          href.includes(".xml") && href.startsWith("/") ? "_self" : "_blank"
        }
      >
        {children}
      </a>
    );
  };
};

export default AnchorLink;
